import { render, staticRenderFns } from "./AccountMigrationNotice.vue?vue&type=template&id=f11f8ab2&scoped=true&"
import script from "./AccountMigrationNotice.vue?vue&type=script&lang=js&"
export * from "./AccountMigrationNotice.vue?vue&type=script&lang=js&"
import style0 from "./AccountMigrationNotice.vue?vue&type=style&index=0&id=f11f8ab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11f8ab2",
  null
  
)

export default component.exports